<script lang="ts">
  import DashCard from '../shared/DashCard.svelte';
  import { Imagenologia, type OrdenImagen } from '../../../lib/api';

  let { limit = 8, onNavigate }: { limit?: number; onNavigate?: (tab: string) => void } = $props();

  let ordenes = $state<OrdenImagen[]>([]);
  let error = $state<string | null>(null);
  let busy = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const pendientes = await Promise.all([
        Imagenologia.ordenes('SOLICITADA'),
        Imagenologia.ordenes('EN_ADQUISICION'),
        Imagenologia.ordenes('ADQUIRIDA'),
      ]);
      ordenes = pendientes.flat().slice(0, limit);
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  async function adquirir(id?: string) {
    if (!id) return;
    busy = id;
    try {
      await Imagenologia.adquirir(id);
      await cargar();
    } catch (e: any) {
      error = e?.message ?? String(e);
    } finally {
      busy = null;
    }
  }

  function badge(estado?: string) {
    if (estado === 'ADQUIRIDA') return 'warn';
    if (estado === 'INFORMADA') return 'ok';
    return '';
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 45000); return () => clearInterval(t); });
</script>

<DashCard title="Cola imagenología" hint="{ordenes.length} órdenes">
  {#snippet actions()}
    <button type="button" class="btn-sm" onclick={cargar}>↻</button>
    {#if onNavigate}<button type="button" class="btn-sm" onclick={() => onNavigate('imagenologia')}>Ver RIS</button>{/if}
  {/snippet}
  {#if error}<p class="err">{error}</p>{/if}
  {#if ordenes.length === 0 && !error}
    <p class="empty">Cola vacía.</p>
  {:else}
    <table class="dash-table">
      <thead><tr><th>Orden</th><th>Paciente</th><th>Estado</th><th class="th-act">Acción</th></tr></thead>
      <tbody>
        {#each ordenes as o (o.id)}
          <tr>
            <td class="dash-mono">{o.numero ?? o.id?.slice(0, 8)}</td>
            <td>{o.pacienteNombre ?? '—'}</td>
            <td><span class="dash-badge {badge(o.estado)}">{o.estado ?? '—'}</span></td>
            <td>
              {#if o.estado === 'SOLICITADA' || o.estado === 'EN_ADQUISICION'}
                <button type="button" class="btn-sm" disabled={busy === o.id} onclick={() => adquirir(o.id)}>
                  {busy === o.id ? '…' : 'Adquirir'}
                </button>
              {/if}
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  {/if}
</DashCard>

<style>
  .btn-sm { border: 1px solid var(--border); background: var(--bg-surface); border-radius: 6px; cursor: pointer; padding: 0.2rem 0.45rem; font-size: 0.72rem; }
  .err, .empty { margin: 0; font-size: 0.85rem; color: var(--text-secondary); }
  .err { color: var(--danger); }
</style>
